exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".opaque[data-v-748ff63a] {\n  opacity: .8;\n}\n.data-text[data-v-748ff63a] {\n  margin-top: -3px;\n  margin-left: .8rem;\n  min-width: 30px;\n}\n", ""]);

// exports
